export default () => {
  return {
    locale: null,
    locales: [
      { name: 'Português - Brasil', code: 'pt-br' },
      { name: 'Español', code: 'es' },
      { name: 'English', code: 'en' },
      { name: 'Français', code: 'fr' },
    ],
  }
}
